import Title from 'app/ui/display/Title';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import BackgroundColourFill from 'app/display/backgrounds/BackgroundColourFill';

export default class HudLevelWin extends Phaser.Group {
  constructor({ game, isLastLevel }) {
    super(game);

    this.isLastLevel = isLastLevel;

    this.background = new BackgroundColourFill({ game, colour: '#000000', alpha: 0.5 });
    this.add(this.background);

    // container to house and position contents
    this.container = this.game.make.group();
    this.add(this.container);

    // baking panel
    this.panel = this.game.make.image(0, 0, 'ui', 'panel_generic');
    this.container.add(this.panel);

    // display Gnasher if player completed the level, display dennis if player did not
    // this.character = this.game.make.image(0, 0, 'modal_characters', 'modal_char_levelwin');
    // this.character.y = 0;
    // this.character.anchor.set(0.5, 0);
    // this.character.x = this.panel.width * 0.6;
    // this.container.addAt(this.character, 0);

    // add title, positiing would depend on what character is being displayed
    this.title = new Title({ game, title: Title.WELLDONE });
    this.title.x = this.panel.width * 0.5 - this.title.width * 0.5;
    this.container.add(this.title);

    // adjust panel positon based on title position
    this.panel.y = this.title.y + this.title.height * 0.3;

    if (isLastLevel) {
      // next level button
      this.btnContinue = new ButtonSimple({ game: this.game, id: 'btn_continue', skin: 'btn_continue' });
      this.btnContinue.x = this.panel.width * 0.5;
      this.btnContinue.y = this.btnReplay.y - this.btnReplay.height - this.btnContinue.height * 0.25;
      this.btnContinue.onInputDown.add(this.handleNextLevel, this);
    } else {
      // next level button
      this.btnContinue = new ButtonSimple({ game: this.game, id: 'btn_nextlevel', skin: 'btn_nextlevel' });
      this.btnContinue.x = this.panel.width * 0.5;
      this.btnContinue.y = this.btnReplay.y - this.btnReplay.height - this.btnContinue.height * 0.25;
      this.btnContinue.onInputDown.add(this.handleNextLevel, this);
    }

    // positioning
    this.game.scale.onSizeChange.add(this.handleScreenResize, this);
    this.fixedToCamera = true;
    this.handleScreenResize();
  }

  /*
  ============================================================================================
    GETTERS
  ============================================================================================
  */

  get height() {
    return this.panel.height + this.panel.y;
  }

  get width() {
    return this.panel.width;
  }

  /*
  ============================================================================================
    EVENT HANDLERS
  ============================================================================================
  */

  handleScreenResize() {
    this.container.x = this.game.width * 0.5 - this.width * 0.5;
    this.container.y = this.game.height * 0.5 - this.height * 0.5;
  }

  handleReplay() {
    this.game.controller.replayLevel();
    this.destroy();
  }

  handleNextLevel() {
    this.game.controller.nextLevel();
    this.destroy();
  }

  handleTryAgain() {
    this.game.controller.replayLevel();
    this.destroy();
  }

  /*
  ============================================================================================
    TOODLES!
  ============================================================================================
  */

  destroy() {
    this.game.scale.onSizeChange.remove(this.handleScreenResize, this);
    if (this.btnTryAgain) {
      this.btnTryAgain.onInputDown.remove(this.handleTryAgain, this);
      this.btnTryAgain.destroy(true);
    }
    if (this.btnContinue) {
      this.btnContinue.onInputDown.remove(this.handleNextLevel, this);
      this.btnContinue.destroy(true);
    }
    if (this.btnReplay) {
      this.btnReplay.onInputDown.remove(this.handleReplay, this);
      this.btnReplay.destroy(true);
    }
    this.title.destroy(true);
    this.panel.destroy(true);
    this.container.destroy(true);

    // nullify
    this.btnTryAgain = null;
    this.btnContinue = null;
    this.btnReplay = null;
    this.highScoreDisplay = null;
    this.scoreDisplay = null;
    this.title = null;
    this.character = null;
    this.panel = null;
    this.container = null;

    // super dupa
    super.destroy(true);
  }
}
